import { Avatar, Card, Flex, Tag } from 'antd';
import React from 'react';
import { TbClipboard, TbPhoneCalling, TbPhoneCheck, TbPhoneX, TbUsers } from 'react-icons/tb';

import DateTime from '~/components/Columns/DateTime';
import PointageResult from '~/components/Columns/PointageResult';

import type { Call } from '~/types/models';

interface ICallCardProps {
  call: Call;
  current?: boolean;
  showContact?: boolean;
  showContext?: boolean;
}

const CallCard: React.FC<ICallCardProps> = ({ call, current, showContact, showContext }): JSX.Element => {
  let callBackgroundColor;
  switch (call.status) {
    case 'Success':
      callBackgroundColor = 'green';
      break;
    case 'Failure':
      callBackgroundColor = 'red';
      break;
  }

  function renderContext(): React.ReactNode {
    if (call.groupId) {
      return (
        <span>
          <TbUsers className='anticon' /> {call.groupName}
        </span>
      );
    }

    if (call.campaignId) {
      return (
        <span>
          <TbClipboard className='anticon' /> {call.campaignName}
        </span>
      );
    }

    return <span />;
  }

  return (
    <Card className={`CallCard${current ? ' CallCard--current' : ''}`}>
      <Flex>
        <Avatar size='large' style={{ backgroundColor: callBackgroundColor }}>
          {call.status === 'Success' && <TbPhoneCheck className='anticon' />}
          {call.status === 'Pending' && <TbPhoneCalling className='anticon' />}
          {call.status === 'Failure' && <TbPhoneX className='anticon' />}
        </Avatar>

        <Flex style={{ width: '100%' }} className='CallCard__Details'>
          <div>
            {showContact && (
              <strong>
                {call.contact?.firstName} {call.contact?.lastName}
              </strong>
            )}

            {!current && (
              <div>
                {call.result === 'NoResult' ? (
                  <div>N&apos;a pas répondu {call.leftMessage && <span>: Laissé un message</span>}</div>
                ) : (
                  (
                    <div>
                      A répondu{' '}
                      <strong>
                        <PointageResult value={call.result} />
                      </strong>
                    </div>
                  ) || <span />
                )}
              </div>
            )}
            {call.tags && call.tags.length > 0 && (
              <div className='CallCard__Tags'>{call.tags?.map((t, i) => <Tag key={i}>{t.name}</Tag>)}</div>
            )}
          </div>

          <div>
            {showContext && renderContext()}
            {call.completed && (
              <div>
                <DateTime value={call.completed} />
              </div>
            )}
            {(!current && call.userName && (
              <div>
                {call.status === 'Pending' ? 'En appel par' : 'Appelé par'} <strong>{call.userName}</strong>
              </div>
            )) || <span />}
            {current && (
              <div>
                <strong>Appel en cours</strong>
              </div>
            )}
          </div>
        </Flex>
      </Flex>

      {call.comment && (
        <Flex>
          <span />
          <div className='CallCard__Comment'>{call.comment}</div>
        </Flex>
      )}
    </Card>
  );
};

export default CallCard;
